var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIconsBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21111 13.6282C6.05798 13.6282 5.92673 13.6064 5.77361 13.5407C5.35798 13.3439 5.13923 12.9064 5.22673 12.447L5.88298 8.96887H1.87986C1.50798 8.96887 1.15798 8.75012 0.982983 8.422C0.807983 8.09387 0.851733 7.67825 1.07048 7.372L5.99236 0.78762C6.25486 0.43762 6.69236 0.30637 7.10798 0.43762C7.52361 0.56887 7.78611 0.940745 7.78611 1.37825V4.46262H12.1174C12.5111 4.46262 12.8611 4.68137 13.0142 5.03137C13.1892 5.38137 13.1236 5.797 12.883 6.08137L6.97673 13.2564C6.77986 13.497 6.49548 13.6282 6.21111 13.6282ZM6.77986 1.37825L1.85798 7.96262L6.47361 7.9845C6.62673 7.9845 6.75798 8.05012 6.84548 8.15949C6.93298 8.26887 6.97673 8.422 6.95486 8.57512L6.18923 12.6439L6.21111 12.6657L12.1392 5.46887L7.30486 5.447C7.04236 5.447 6.80173 5.22825 6.80173 4.94387L6.77986 1.37825Z",
    fill: "#3A7463"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIconsBolt);
export default __webpack_public_path__ + "static/media/tag-icons-bolt.39a9794f0b35bb0e503c6c4af3002673.svg";
export { ForwardRef as ReactComponent };